<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch09">
<div class="chapterHead">
<h2 class="chapterTitle3"><span class="xrefInternal"><a href="#/contents#ch_09"><span class="bold">B<span class="smallCaps">ONO</span></span></a></span><span class="footnoteRef"><span href="#/footnote#footnote9" id="fn9" title="Link target outside of Sample"><sup>*</sup></span></span></h2></div>
<div class="chapterBody">
<p class="image1"><img alt="image" src="37.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch09.vue?478f6eaf